import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {SETTINGS} from "../config/common.settings";

@Injectable({
  providedIn: 'root'
})
export class GoogleMatrixService {

  constructor(private http: HttpClient) {
  }

  postDistanceMatrix(payload: any): Observable<any> {
    return this.http.post(`${SETTINGS.BASE_API}/distance/get-matrix`, payload);
  }
}
